"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SlideAnimation = void 0;

var _styledComponents = require("styled-components");

var _styleHelpers = require("../styleHelpers");

var _InOutAnimation = require("./InOutAnimation");

var transformInterpolateFn = function transformInterpolateFn(axis, directionMultiplier) {
  return function (props) {
    var reverseMultiplier = props.reverse ? -1 : 1;
    var axisMultiplier = axis === 'X' ? 0.5 : 1;
    return props.visible ? "translate".concat(axis, "(0)") : "translate".concat(axis, "(").concat(reverseMultiplier * directionMultiplier * axisMultiplier * 25, "%)");
  };
};

var topStyles = (0, _styledComponents.css)(["transform:", ";"], transformInterpolateFn('Y', -1));
var bottomStyles = (0, _styledComponents.css)(["transform:", ";"], transformInterpolateFn('Y', 1));
var rightStyles = (0, _styledComponents.css)(["transform:", ";"], transformInterpolateFn('X', 1));
var leftStyles = (0, _styledComponents.css)(["transform:", ";"], transformInterpolateFn('X', -1));
var stackAnimationBase = (0, _styledComponents.css)(["transition:", ";opacity:0;", ""], function (props) {
  return (0, _styledComponents.css)(["opacity ", "ms,transform ", "ms"], props.duration, props.duration);
}, (0, _styleHelpers.conditionalStyles)('side', {
  top: topStyles,
  bottom: bottomStyles,
  right: rightStyles,
  left: leftStyles
}));
var stackAnimationEnter = (0, _styledComponents.css)(["opacity:1;transform:translateY(0) translateX(0);"]);
var stackAnimationExit = (0, _styledComponents.css)(["opacity:0;", ""], (0, _styleHelpers.conditionalStyles)('side', {
  top: topStyles,
  bottom: bottomStyles,
  right: rightStyles,
  left: leftStyles
}));
var SlideAnimation = (0, _InOutAnimation.createInOutAnimation)({
  baseStyles: stackAnimationBase,
  enterStyles: stackAnimationEnter,
  exitStyles: stackAnimationExit
});
exports.SlideAnimation = SlideAnimation;